<template>
  <div class="dashboard page-content__header-description">
    <h6 v-show="isCustomer" class="info_banner">
      <span class="important-text">Important Notice!</span> This platform closed
      as of Jan 6, 2025. Please switch to our mobile app:
      <a
        href="https://apps.apple.com/us/app/arnergy-solarbase/id6469667753"
        class="app-link"
        target="_blank"
      >
        IOS</a
      ><span>|</span>
      <a
        href="https://play.google.com/store/apps/details?id=com.arnergy.mos"
        class="app-link"
        target="_blank"
      >
        Android
      </a>
    </h6>
    <h1 style="flex: 1" class="page-title">Performance</h1>
    <!-- class="widget widget-alpha widget-alpha--color-amaranth" -->
    <div
      v-if="showOffOnlinelineDevices != null"
      style="flex-flow: row; display: flex; flex: 1; margin-bottom: 8px"
    >
      <span
        style="float: right; display: block; display: flex"
        class="label-container"
      >
        <!-- {{value}} -->
        <!-- {{showOffOnlinelineDevices}} -->
        <!-- :type="" -->
        <div>
          <span
            class="default-label"
            :class="{
              'active-blue-filter':
                showOffOnlinelineDevices === 3 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('All')"
          >
            <p class="blue-label">All</p>
            <p class="device-amount">
              {{ pagination.deviceAnalytics.totalDetectableDevices }}
            </p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{
              'active-green-filter':
                showOffOnlinelineDevices === 1 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('Online')"
          >
            <p class="green-label">Online</p>
            <p class="device-amount">
              {{ pagination.deviceAnalytics.onLines }}
            </p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{
              'active-yellow-filter':
                showOffOnlinelineDevices === 2 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('Offline')"
          >
            <p class="yellow-label">Offline</p>
            <p class="device-amount">
              {{ pagination.deviceAnalytics.offLines }}
            </p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{
              'active-yellow-filter':
                showOffOnlinelineDevices === 5 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('ExclusionList')"
          >
            <p class="yellow-label">Exclusions</p>
            <p class="device-amount">
              {{ pagination.deviceAnalytics.exclusionList }}
            </p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{
              'active-red-filter':
                showOffOnlinelineDevices === 4 && !showCritical
            }"
            @click="toggleShowOfflineOnlineDevices('Alarm')"
          >
            <p class="red-label">Alarms</p>
            <p class="device-amount">{{ pagination.deviceAnalytics.alarms }}</p>
          </span>
        </div>
        <div>
          <span
            class="default-label"
            :class="{ 'active-orange-filter': showCritical }"
            @click="toggleShowOfflineOnlineDevices('critical')"
          >
            <p class="orange-label">Inverter Not Detected</p>
            <p class="device-amount">
              {{ pagination.deviceAnalytics.notDetectedDevices }}
            </p>
          </span>
        </div>
        <div v-show="true ? usertype == 'admin' : false">
          <span
            class="default-label bg-secondary"
            @click="downloadAllInstallations"
          >
            <p class="text-white">Download all</p>
          </span>
        </div>
      </span>
      <!--
        <vk-iconnav>
        <vk-iconnav-item
          class="critical_pin"
          style="color: red !important"
          href="#"
          @click="toggleShowOfflineOnlineDevices('critical')"
          icon="warning"
        ></vk-iconnav-item>
        <vk-iconnav-item
          href="#"
          @click="searchToggle"
          icon="search"
        ></vk-iconnav-item>
        <i
          class="el-icon-s-operation"
          @click="toggleFilters"
          style="font-size: 16pt"
        ></i>
        <vk-iconnav-item href="#" icon="copy"></vk-iconnav-item>
        <vk-iconnav-item href="#" icon ="trash"></vk-iconnav-item>
      </vk-iconnav> -->
    </div>
    <!-- widget widget-alpha widget-alpha--color-amaranth -->
    <div class style="display: flex; flex-flow: row">
      <div
        class="table-header-custom"
        style="margin-bottom: 12px; margin-right: 5pt"
        v-show="showFilters"
      >
        <el-dropdown>
          <el-button size="small" round class="el-dropdown-link">
            {{
              this.filterFirmWarVersion ? this.filterFirmWarVersion : "Version"
            }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :key="fv.id" v-for="fv in uniqueFV">
              <span @click="handleVersionFilterEnabler(fv.FV)">
                {{ fv.FV }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
          <!-- <i>{{this.filterFirmWarVersion}}</i> -->
        </el-dropdown>
      </div>
      <div
        class="table-header-custom border"
        style="margin-bottom: 12px; margin-right: 5pt"
        v-show="showFilters"
      >
        <el-dropdown>
          <el-button size="small" round class="el-dropdown-link">
            {{ this.filterSectorVal ? this.filterSectorVal : "Sector" }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :key="item.id" v-for="item in uniqueSectors">
              <span @click="handleSectorFilterEnabler(item.sector)">
                {{ item.sector }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
          <!-- <i>{{this.filterSectorVal}}</i> -->
        </el-dropdown>
      </div>
      <div
        class="table-header-custom border"
        style="margin-bottom: 12px; margin-right: 5pt"
        v-show="showFilters"
      >
        <el-dropdown>
          <el-button size="small" round class="el-dropdown-link">
            {{
              this.filterPaymentModel
                ? this.filterPaymentModel
                : "Payment Model"
            }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :key="item.id" v-for="item in uniquePaymentModel">
              <span
                @click="handlePaymentModelFilterEnabler(item.paymentModel)"
                >{{ item.paymentModel }}</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
          <!-- <i>{{this.filterSectorVal}}</i> -->
        </el-dropdown>
      </div>
    </div>

    <div class="display-search-bar">
      <div
        class="info-container"
        v-show="paginatedInfo.ofText && !getLoadingState"
      >
        <h3>
          Showing
          {{
            paginatedInfo.total > 0
              ? `${paginatedInfo.first} - ${showNotDetectedInv ||
                  paginatedInfo.last}
          ${paginatedInfo.ofText} ${showNotDetectedInv ||
                  paginatedInfo.total} ${
                  paginatedInfo.total > 1 ? "Devices" : "Device"
                }`
              : "no device"
          }}
        </h3>
        <div>
          <el-tooltip
            class
            effect="dark"
            :content="getHint(showOffOnlinelineDevices)"
            placement="bottom"
          >
            <i class="fa fa-info-circle info-icon"></i>
          </el-tooltip>
        </div>
      </div>

      <h1 v-show="getLoadingState"></h1>
      <div class="t" v-show="showSearch && !showCritical">
        <el-input
          style="width: 50%"
          placeholder="Search All Devices"
          prefix-icon="el-icon-search"
          class="el-input el-input--prefix"
          v-model="searchTerm"
        ></el-input>
      </div>
    </div>

    <div class="main-container">
      <!-- {{showOffOnlinelineDevices===2 && !showCritical +': Offline'}}
      {{showOffOnlinelineDevices===3 && !showCritical +': All'}}
      {{showOffOnlinelineDevices===1 && !showCritical +': Online'}}-->
      <div
        v-if="
          showOffOnlinelineDevices === 2 && !showCritical && !getLoadingState
        "
      >
        <OfflineDevices
          v-show="showOffOnlinelineDevices === 2 && !showCritical"
          :showCritical="showCritical"
          :activeTab="showOffOnlinelineDevices === 2 && !showCritical"
          :showOfflineDevices="showOffOnlinelineDevices"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :searchTerm="searchTerm"
          :filteredOffLineDevices="getAllFilteredOfflineDevice"
          @paginated-info="paginatedInfo = $event"
          @sortData="sortDevice"
          :formatDate="formatDate"
          :addToExclusionList="addToExclusionList"
        />
      </div>
      <div
        v-if="
          showOffOnlinelineDevices === 4 && !showCritical && !getLoadingState
        "
      >
        <AlarmDevices
          v-show="showOffOnlinelineDevices === 4 && !showCritical"
          :showCritical="showCritical"
          :activeTab="showOffOnlinelineDevices === 4 && !showCritical"
          :showAlarmDevices="showOffOnlinelineDevices"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :searchTerm="searchTerm"
          :filteredAlarmDevices="getAllFilteredAlarms"
          @paginated-info="paginatedInfo = $event"
          @sortData="sortDevice"
          :formatDate="formatDate"
        />
      </div>
      <div
        v-if="
          showOffOnlinelineDevices === 1 && !showCritical && !getLoadingState
        "
      >
        <OnLineDevices
          :v-show="showOffOnlinelineDevices === 1 && !showCritical"
          :showOnlineDevices="showOffOnlinelineDevices"
          :activeTab="showOffOnlinelineDevices === 1 && !showCritical"
          :showCritical="showCritical"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :searchTerm="searchTerm"
          :filteredOnlineDevices="filteredOnlineDevices"
          @paginated-info="paginatedInfo = $event"
          @sortData="sortDevice"
          :formatDate="formatDate"
          :addToExclusionList="addToExclusionList"
        />
      </div>
      <div
        v-if="
          showOffOnlinelineDevices === 3 && !showCritical && !getLoadingState
        "
      >
        <AllDevices
          :v-show="showOffOnlinelineDevices === 3 && !showCritical"
          :showAllDevices="showOffOnlinelineDevices"
          :activeTab="showOffOnlinelineDevices === 3 && !showCritical"
          :showCritical="showCritical"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :total="pagination.deviceAnalytics.totalDetectableDevices"
          :searchTerm="searchTerm"
          :filteredAllDevices="getAllFilteredDevice"
          @paginated-info="paginatedInfo = $event"
          @sortData="sortDevice"
          :formatDate="formatDate"
          :addToExclusionList="addToExclusionList"
        />
      </div>

      <div
        v-if="
          showOffOnlinelineDevices === 5 && !showCritical && !getLoadingState
        "
      >
        <ExclusionDevices
          :v-show="showOffOnlinelineDevices === 5 && !showCritical"
          :showAllDevices="showOffOnlinelineDevices"
          :activeTab="showOffOnlinelineDevices === 5 && !showCritical"
          :showCritical="showCritical"
          :tableRowClicked="tableRowClicked"
          :fields_="fields_"
          :items="items"
          :total="pagination.deviceAnalytics.totalDetectableDevices"
          :searchTerm="searchTerm"
          :filteredAllDevices="getAllFilteredDevice"
          @paginated-info="paginatedInfo = $event"
          @sortData="sortDevice"
          :formatDate="formatDate"
          :removeFromExclusionList="removeFromExclusionList"
        />
      </div>

      <div
        v-if="
          showOffOnlinelineDevices === null && !showCritical && !getLoadingState
        "
      >
        no data
      </div>
      <div
        style="height: 300px; display: flex; alignItems: center; justifyContent: center"
        v-if="getLoadingState"
      >
        Loading, please wait...
      </div>
      <div style="width: 100%" v-if="showCritical && !getLoadingState">
        <h2>Inverter not detected</h2>
        <!-- {{criticalSystems}} -->
        <vue-good-table
          class="table"
          :columns="criticalColumns"
          :rows="criticalSystems"
          :line-numbers="true"
        >
          <!-- <template slot="table-row" slot-scope="props" style="background: red;">
            <span v-if="props.column.field == 'status'">
              <div
                class="table_status"
                :class="{
                  'badge-danger': statusCalc(props.row.TimeStamp),
                  'badge-success': !statusCalc(props.row.TimeStamp)
                }"
              ></div>
            </span>
            <span v-else-if="props.column.field == 'ownerName'">{{ props.row.ownerName }}</span>
            <span v-else-if="props.column.field == 'deviceType'">{{ props.row.deviceType }}</span>
            <span v-else-if="props.column.field == 'deviceType'">{{ props.row.deviceType }}</span>
            <span v-else-if="props.column.field == 'version'">{{ props.row.version }}</span>
            <span v-else-if="props.column.field == 'panelpower'">{{ props.row.panelpower }}</span>
            <span v-else-if="props.column.field == 'InverterId'">{{ props.row.InverterId }}</span>
            <span v-else-if="props.column.field == 'lastseen'">{{ timeAgo(props.row.Timestamp) }}</span>
            <span
              v-else-if="props.column.field == 'batterystatus'"
              style="display: flex; flex-flow: row;"
            >
              <battery
                :mini="true"
                :width="`18px`"
                :height="`10px`"
                :direction="`y`"
                style="margin-top: 5px;"
                :level="props.row.BatteryCapacity"
              ></battery>

              <span>{{ `${props.row.BatteryCapacity * 1}%` }}</span>
            </span>

            <span v-else>{{ props.row[props.column.field] }}</span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>-->
        </vue-good-table>
      </div>
    </div>

    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
  <!-- </div> -->
</template>

<script>
/* eslint-disable */
// import Widget from "../../vuestic-components/vuestic-widget/VuesticWidget";
// import Modal from "../../vuestic-components/vuestic-modal/VuesticModal";
// import InstallationStat from "./installationStat";
// import VuesticSimpleSelect from "../../vuestic-components/vuestic-simple-select/VuesticSimpleSelect";

import Vue from "vue";
import Simplert from "vue2-simplert";
import powerStat from "./powerStat";
import moment from "moment";
import Battery from "../kitchen/grey-battery";
import { mapGetters, mapActions } from "vuex";
import { Tooltip } from "element-ui";
import OfflineDevices from "./widgets/offlineDevices2";
import AlarmDevices from "./widgets/alarmDevices2";
import OnLineDevices from "./widgets/onLineDevices2";
import AllDevices from "./widgets/allDevices2";
import ExclusionDevices from "./widgets/exclusionDevices.vue";
import { Icon, Iconnav, IconnavItem } from "vuikit";
import { debounce } from "../../../utils/util";
import fileDownload from "js-file-download";
import {
  Badge
  // ...
} from "element-ui";
import Noty from "noty";

Vue.use(Badge);
let items = [];

export default {
  name: "dashboard",
  searchdata: "",
  components: {
    // Widget,
    powerStat,
    OfflineDevices,
    AlarmDevices,
    OnLineDevices,
    AllDevices,
    ExclusionDevices,
    // Modal,
    // VuesticSimpleSelect,
    Simplert,
    Battery,
    "vk-iconnav": Iconnav,
    "vk-icon": Icon,
    "vk-iconnav-item": IconnavItem,
    "el-tooltip": Tooltip
  },
  computed: {
    ...mapGetters([
      "DeviceList",
      "getUserByDevice",
      "loadingState",
      "getUserSession",
      "graphDeviceDetails",
      "offLineDeviceList",
      "onLineDevices",
      "uniqueFV",
      "devicePayload",
      "uniqueSectors",
      "uniquePaymentModel",
      "filteredAllDevices",
      "getAssignedDevices",
      "filteredOnlineDevices",
      "filteredOffLineDevices",
      "filteredAlarmDevices",
      "getPerformanceFilter",
      "getGlobalTableOptions"
    ]),
    getAllFilteredDevice: {
      get() {
        return this.filteredAllDevices;
      }
    },
    getAllFilteredOfflineDevice: {
      get() {
        return this.filteredOffLineDevices;
      }
    },
    getAllFilteredAlarms: {
      get() {
        return this.filteredAlarmDevices;
      }
    },
    getSortOrder: {
      get() {
        return {
          sortField: this.sortField,
          sortOrder: this.sortOrder
        };
      }
    },
    tableOptions: {
      get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    getParams: {
      get() {
        return {
          page: this.tableOptions.currentPage,
          limit: this.tableOptions.currentPerPage,
          filter: this.filterMode,
          search: this.searchTerm,
          sortField: this.sortField,
          sortOrder: this.sortOrder
        };
      }
    },
    getLoadingState: {
      get() {
        return this.loadingState || this.exclusionLoading;
      }
    },
    getExclusionLoadingState: {
      get() {
        return this.exclusionLoading;
      }
    },
    pagination: {
      get() {
        return this.devicePayload;
      }
    },
    showNotDetectedInv: {
      get() {
        return this.notDetectedInverter;
      }
    },
    criticalSystems: {
      //
      get() {
        let filteredIssues = this.filterIssues();
        if (filteredIssues) {
          this.setCriticalSystems(filteredIssues);
          // console.log("SHould Log");
          return filteredIssues;
        } else {
          return [];
        }
      }
      // set(newValue, oldValue){

      // }
    }
  },
  data() {
    return {
      totalDevicesShowing: "",
      usertype: localStorage.roleType,
      paginatedInfo: {},
      showSearch: true,
      value: "live",
      searchTerm: "",
      sortField: "",
      sortOrder: "",
      details: "devicePerformance",
      myDevices: [],
      fetchData: [],
      retData: {},
      isCustomer: false,
      notDetectedInverter: "",
      showCritical: false,
      loading: true,
      exclusionLoading: false,
      showOffOnlinelineDevices: null,
      showAllDevices: false,
      showOnlineOfline: true,
      showOnlineButton: true,
      showFilters: true,
      filterFirmWarVersion: "",
      filterSectorVal: "",
      filterPaymentModel: "",
      filterMode: "",
      formDevice: {
        DeviceID: null,
        device_type: {
          name: "Arnergy 5000",
          description:
            "Bundled with : 3 LED bulbs, FM Radio and 1 x 20Wp High Efficiency Solar Panel.",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        location: {
          address: null,
          latitude: null,
          longitude: null
        },
        customer: {
          name: null,
          phone: null
        },
        subscription_type: {
          name: "Monthly Subscription",
          description: "User Pays Monthly",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        TimeStamp: new Date(),
        updatedAt: new Date(),
        outright_cost: 96796,
        initial_cost: 98533,
        installment_cost: 626882
      },
      deviceOptions: [
        "Arnergy 300",
        "Arnergy 1000",
        "Arnergy 2000",
        "Arnergy 5000"
      ],
      simpleSelectModel: "",
      timeRightNow: moment(),
      items: items,
      criticalColumns: [
        {
          key: "ownerName",
          label: "OWNED BY",
          sortable: true,
          field: "ownerName",
          filterable: true
        },
        {
          key: "deviceType",
          label: "DEVICE TYPE",
          sortable: "true",
          field: "InstallType",
          filterable: true
        },
        {
          key: "version",
          label: "VERSION",
          sortable: "true",
          field: "Version",
          filterable: true
        },
        {
          key: "InverterId",
          label: "DEVICE ID",
          sortable: "true",
          field: "DeviceID",
          filterable: true
        },
        {
          key: "Timestamp",
          label: "LAST SEEN",
          sortable: "true",
          field: "Timestamp",
          filterable: true
        }
      ],
      fields_: [
        {
          key: "action",
          label: "",
          field: "actions",
          sortable: false
        },
        {
          key: "status",
          label: "STATUS",
          field: "status"
        },
        {
          key: "ownerName",
          label: "OWNED BY",
          sortable: "true",
          field: "ownerName",
          type: "text",
          filterable: true
        },
        {
          key: "InverterId",
          label: "Device ID",
          sortable: "true",
          field: "InverterId",
          type: "text",
          filterable: true
        },
        // {
        //   key: "installedPV",
        //   label: "INSTALLED PV",
        //   sortable: false,
        //   field: "installedPV",
        //   filterable: true,
        //   hidden:
        //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
        // },
        {
          key: "installedCapacity",
          label: "INSTALLED PV / CAPACITY",
          sortable: false,
          field: "installedCapacity",
          filterable: true,
          sortFn: this.numSort,
          firstSortType: "desc"
          // formatFn: this.formatCap,
        },
        // {
        //   key: "FV",
        //   label: "FIRMWARE VERSION",
        //   sortable: "true",
        //   field: "FV",
        //   filterable: true,
        // },
        {
          key: "version",
          label: "VERSION / FIRMWARE VERSION",
          sortable: "true",
          field: "version",
          filterable: true
        },
        // {
        //   key: "InverterId",
        //   label: "DEVICE ID",
        //   sortable: "true",
        //   field: "InverterId",
        //   filterable: true,
        //   // filterOptions: {
        //   //   enabled: true
        //   // }
        // },
        {
          key: "panelpower",
          label: "PV POWER",
          sortable: "true",
          field: "panelpower",
          filterable: true,
          type: "number",
          formatFn: this.formatFnPvP
        },
        {
          key: "batteryMode",
          label: "DEVICE STATUS",
          sortable: false,
          field: "batteryMode",
          filterable: true
        },
        {
          key: "BatteryCapacity",
          label: "BATTERY",
          sortable: "true",
          field: "BatteryCapacity",
          filterable: true,
          sortFn: function(x, y, col, rowX, rowY) {
            // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
            // x = Number(x);
            // y = Number(y);
            // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
            // return x < y ? -1 : x > y ? 1 : 0;
          }
        },
        // {
        //   key: "expiry",
        //   label: "EXPIRY DATE",
        //   sortable: "true",
        //   field: "expiry",
        //   filterable: true
        // },
        // {
        //   key: "contractualLoad",
        //   field: "contractualLoad",
        //   label: "Contractual Load",
        //   sortable: true,
        //   filterable: true,
        //   hidden:
        //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
        // },
        {
          key: "OutputLoadPercent",
          label: "CONTRACTUAL LOAD / LOAD %",
          sortable: "true",
          field: "OutputLoadPercent",
          filterable: true,
          sortFn: this.numSort
        },
        {
          key: "deviceBrand",
          label: "Device type",
          sortable: false,
          field: "deviceBrand",
          filterable: true,
          type: "text",
        },
        {
          key: "Time",
          field: "Time",
          label: "TIME",
          sortable: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
          filterable: true,
          hidden:
            this.$can("am", "customer") || this.$can("am", "sm") ? true : false
        }
      ],
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },
  methods: {
    ...mapActions([
      "performanceGraphCall2",
      "handleFilters",
      "clearFilters",
      "setPerformanceFilter",
      "setGlobalTableOptions",
      "setCriticalSystems"
    ]),
    onClose() {},
    formatCap: function(value) {
      return value + "kVA";
    },
    showToast(text, type = "success") {
      new Noty({
        theme: "bootstrap-v3",
        text: text,
        type,
        timeout: 1000
      }).show();
    },
    addToExclusionList(deviceId) {
      this.exclusionLoading = true;

      const HTTP = this.$httpUtils.FastAPIHTTP;
      HTTP.post("/devices/add-to-exclusion", { deviceId: deviceId })
        .then(async res => {
          this.exclusionLoading = false;
          this.showToast(res.data.message);
          await this.getDevices({ ...this.getParams });
          this.hide();
        })
        .catch(e => {
          this.exclusionLoading = false;
          this.showToast(e.response.data.detail, "error");
        });
    },
    removeFromExclusionList(deviceId) {
      this.exclusionLoading = true;

      const HTTP = this.$httpUtils.FastAPIHTTP;
      HTTP.delete(`/devices/exclusion-list/${deviceId}`)
        .then(async res => {
          this.exclusionLoading = false;
          this.showToast(res.data.message);
          await this.getDevices({ ...this.getParams });
          this.hide();
        })
        .catch(e => {
          this.showToast(e.response.data.detail, "error");
          this.exclusionLoading = false;
        });
    },
    formatFnPvP(v) {
      return v + "kW";
    },
    selectedField(field) {
      switch (field) {
        case "version":
          return "Version";
        default:
          return field;
      }
    },
    async getDevices(payload) {
      // console.log(payload, '*****')
      if (this.$can("am", "customer")) {
        console.log("customer");
        // I am a customer...
        // console.log({whoami:"Customer"});
        const deviceIds =
          this.getAssignedDevices != null
            ? this.getAssignedDevices
            : await this.getCurrentCustomerDeviceIds(); // ==> ['416931', '416850'];
        // alert(deviceIds);
        if (deviceIds.length < 1) {
          this.showOffOnlinelineDevices = null;
          return;
        }
        await this.performanceGraphCall2({
          timeRN: this.timeRightNow,
          arrayOfIds: deviceIds,
          ...payload,
          filter: this.selectMode(this.getPerformanceFilter)
        });
      } else if (this.$can("am", "sm")) {
        // I am a section manager...
        console.log("section manager");
        let assignedDevices = [];
        try {
          assignedDevices = JSON.parse(this.getUserSession.assignedDevices);
        } catch (error) {
          assignedDevices = this.getUserSession.assignedDevices.split(",");
        }
        await this.performanceGraphCall2({
          timeRN: this.timeRightNow,
          arrayOfIds: assignedDevices,
          ...payload,
          filter: this.selectMode(this.getPerformanceFilter)
        });
        // console.log({ assignedDevices });
      } else if (this.$can("manage", "allDevices")) {
        // console.log('everyone', this.getPerformanceFilter)
        await this.performanceGraphCall2({
          timeRN: this.timeRightNow,
          ...payload,
          filter: this.selectMode(this.getPerformanceFilter)
        });
      }
    },
    numSort(x, y, col, rowX, rowY) {
      x = Number(x);
      y = Number(y);
      return x < y ? -1 : x > y ? 1 : 0;
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
      this.filterFirmWarVersion = "";
      this.filterSectorVal = "";
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.clearFilters();
    },
    selectMode(mode) {
      if (mode == 1) {
        return "online";
      }
      if (mode == 6) {
        return "not-detected";
      }
      if (mode == 5) {
        return "exclusion-list";
      }
      if (mode == 4) {
        return "alarm";
      }
      if (mode == 3) {
        return undefined;
      }
      if (mode == 2) {
        return "offline";
      }
    },
    getHint(mode) {
      if (mode == 1) {
        return "Devices that are detected in the last 90 minutes excluding devices on exclusion";
      }
      if (mode == 6) {
        return "Devices that are not detected";
      }
      if (mode == 5) {
        return "Devices that are excluded from all devices";
      }
      if (mode == 4) {
        return "Devices with various alarm information";
      }
      if (mode == 3) {
        return "All Devices excluding those that are on exclusion";
      }
      if (mode == 2) {
        return "Devices that are not detected in the last 90 minutes excludding devices on exclusion";
      }
    },
    handleVersionFilterEnabler(fv) {
      this.filterFirmWarVersion = fv === "clear" ? "" : fv;
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handleSectorFilterEnabler(sector) {
      this.filterSectorVal = sector == "clear" ? "" : sector;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handlePaymentModelFilterEnabler(paymentModel) {
      this.filterPaymentModel = paymentModel == "clear" ? "" : paymentModel;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    downloadAllInstallations() {
      const HTTP = this.$httpUtils.FastAPIHTTP;
      this.showToast("Processing...");
      HTTP.get("/installation/users_installation/", { responseType: "blob" })
        .then(res => {
          fileDownload(res.data, "installations.csv");
        })
        .catch(e => {
          this.showToast(e);
        });
    },
    toggleShowOfflineOnlineDevices(status) {
      // console.log({ status });
      switch (status) {
        case "critical":
          this.toggleCritical();
          this.totalDevicesShowing = this.filterIssues().length;
          this.filterMode = "not-detected";
          this.showOffOnlinelineDevices = 6;
          this.setPerformanceFilter(6);
          this.getDevices({
            ...this.getParams,
            filter: "not-detected",
            limit: this.devicePayload.deviceAnalytics.notDetectedDevices
          });
          this.notDetectedInverter = this.devicePayload.deviceAnalytics.notDetectedDevices;
          break;
        case "Offline":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 2;
          this.totalDevicesShowing = this.filteredOffLineDevices.length;
          this.setPerformanceFilter(2);
          this.filterMode = "offline";
          this.getDevices({ ...this.getParams, filter: "offline" });
          this.notDetectedInverter = "";
          break;
        case "Alarm":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 4;
          this.totalDevicesShowing = this.filteredAlarmDevices.length;
          this.setPerformanceFilter(4);
          this.filterMode = "alarm";
          this.getDevices({ ...this.getParams, filter: "alarm" });
          this.notDetectedInverter = "";
          break;
        case "Online":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          this.filterMode = "online";
          this.getDevices({ ...this.getParams, filter: "online" });
          this.notDetectedInverter = "";
          break;
        case "All":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 3;
          this.totalDevicesShowing = this.filteredAllDevices.length;
          this.setPerformanceFilter(3);
          this.filterMode = "";
          this.getDevices({ ...this.getParams });
          this.notDetectedInverter = "";
          break;
        case "ExclusionList":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 5;
          this.totalDevicesShowing = this.filteredAllDevices.length;
          this.setPerformanceFilter(5);
          this.filterMode = "exclusion-list";
          this.getDevices({ ...this.getParams, filter: "exclusion-list" });
          this.notDetectedInverter = "";
          break;
        default:
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          this.notDetectedInverter = "";
          this.filterMode = "";
          break;
      }

      let tmpState = {
        ...this.getGlobalTableOptions,
        performance: {
          ...this.getGlobalTableOptions.performance,
          currentPage: 1
        }
      };
      this.setGlobalTableOptions(tmpState);
      // if (this.activeTab === true) {
      //   console.log("Online"+this.activeTab );

      // }
      //toggleCritical()
      // this.showOffOnlinelineDevices = !status;
      // if (this.showOfflineDevices) {
      //   this.showCritical = false;
      // }
      // this.showCritical=
    },
    filterIssues() {
      if (this.DeviceList.length > 0) {
        return this.DeviceList.filter(x => {
          if (typeof x === "object") {
            // console.log({ x: typeof x });
            if (x.payload) {
              return x.payload.InverterDetected == "NO";
              // console.log({ x: typeof x.payload });
            } else {
              // console.log({ noPayload: x });
            }
          } else {
            // console.log({ xNotObject: x });
          }
        }).reduce((acc, cur) => {
          // console.log(cur);
          let _tmp = {
            ...cur.payload,
            ownerName:
              cur["owner"] && cur["owner"].length > 0 && cur["owner"][0]
                ? cur["owner"][0]["name"]
                : "Unassigned"
          };
          return [...acc, _tmp];
        }, []);
      }
    },
    toggleCritical() {
      this.showCritical = !this.showCritical;
      // console.log({ Oop: this.DeviceList });
    },
    searchToggle() {
      this.showSearch = !this.showSearch;
    },
    toggleShowAllDevices(showAllDevices) {
      console.log({ showAllDevices });
    },
    changeToggle() {
      //console.log("i am here",this.value);
      if (this.value == "all") {
        this.$router.push({
          path: "/performance/all"
        });
      } else {
        this.$router.push({
          path: "/performance/live"
        });
      }
    },
    tableRowClicked(params) {
      if (params.row.batteryMode !== "inv not detected") {
        this.navTo(params.row);
      }
    },
    getFetchData(CID) {
      try {
        return (
          this.fetchData.find(x => x.CID == CID || x.solarKitIds == CID) || {
            name: "Arnergy Solar",
            userId: "5"
          }
        );
      } catch (error) {
        return { name: "Arnergy Solar", userId: "5" };
      }
      //.then(res=> {return res[0].name}).catch((err)=> {return''})
      // return null || this.fetchData.filter(x => x.solarKitIds == inverterId)[0].name
    },
    filterIt(arr, searchKey) {
      if (searchKey.length < 3) return arr;
      else
        return arr.filter(obj =>
          Object.keys(obj).some(key => obj[key].includes(searchKey))
        );
    },
    handleStringConversion(data) {
      return typeof data === "string" ? data : data.toString();
    },
    handleFilter(data) {
      let type = this.$route.params["live"] == "live" ? true : false;
      return data.filter(x => {
        // console.log(this.statusCalc(x.TimeStamp));

        // console.log(x && type ? this.statusCalc(x.TimeStamp) == false : true);
        return x && type ? this.statusCalc(x.TimeStamp) == false : true;
      });
    },
   
    roundUp(num) {
      return num.toFixed(2);
    },
    async getDevice(inverterId) {
      const context = this;
      const HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations`;
      return await HTTP.get(url)
        .then(response => {
          context.fetchData = response.data;
          // console.log(context.fetchData);
        })
        .catch(error => {
          return "not assign";
          //console.log("error", error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    panelPowerReduce(InverterData, version = "v3") {
      var power = InverterData.reduce((acc, parameter) => {
        let powerKey = `PVCgP${version == "v4" ? "1" : ""}`;
        // console.log("i am parameter", Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    submitAddForm() {
      // console.log(JSON.stringify(this.formDevice));
      var dataParam = this.formDevice;
      if (
        dataParam.DeviceID === null ||
        dataParam.device_type.name === null ||
        dataParam.location.address === null ||
        dataParam.customer.name === null ||
        dataParam.customer.phone === null ||
        dataParam.DeviceID === "" ||
        dataParam.device_type.name === "" ||
        dataParam.location.address === "" ||
        dataParam.customer.name === "" ||
        dataParam.customer.phone === ""
      ) {
        let obj = {
          title: "Please fill all fields!!!",
          message: "",
          type: "error",
          onClose: this.onClose
        };
        this.$refs.simplert.openSimplert(obj);
        // alert('Please fill all fields!!!')
      } else {
        const me = this;
        const HTTP = this.$httpUtils.instance;
        HTTP.post("/devices", me.formDevice)
          .then(function(response) {
            me.fetchDevices();
            let obj = {
              title: "Device Created!!!",
              message: "",
              type: "info",
              onClose: me.onClose
            };
            me.$refs.simplert.openSimplert(obj);
          })
          .catch(function(error) {
            // console.log(error);
            let obj = {
              title: "Error, Try again!!!",
              message: "",
              type: "error",
              onClose: me.onClose
            };
            me.$refs.simplert.openSimplert(obj);
          });
        me.hideControl();
      }
    },
    showFormPop() {
      this.$refs.formModal.open();
    },
    hideControl() {
      this.$refs.formModal.cancel();
    },
    formatDate(_date) {
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    navTo(device) {
      let { id, version, InverterId } = device;
      // let { DeviceID } = device;

      this.$router.push({
        name: "devicePerformanceV3",
        params: {
          deviceId: id ? id : InverterId,
          version: version ? version : "v2"
        }
      });
      // console.log(this.details,device)
    },
    roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json(data) {
      return JSON.parse(data);
    },
    countErrors(Warning) {
      var excluded = [
        "id",
        "deviceID",
        "TimeStamp",
        "TimeStamp",
        "updatedAt",
        "lineFail"
      ];
      var totalErr = 0;
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Warning[property] > 0) {
            totalErr++;
            // console.log(property);
          }
        }
      }
      return totalErr;
    },
    errorCalc(Warning) {
      var excluded = [
        "id",
        "deviceID",
        "TimeStamp",
        "TimeStamp",
        "updatedAt",
        "lineFail"
      ];
      var totalErr = 0;
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Warning[property] > 0) {
            totalErr++;
            // console.log(property);
          }
        }
      }
      // var msg_ = ' Error'
      if (totalErr > 0) {
        return true;
      }
      return false;
    },
    findDeviceData(dataset, key, value) {
      const res = dataset.filter(x => x[key] == value);
      return res.length > 0 ? res : undefined;
    },
    batteryMode(deviceID) {
      // console.log(this.DeviceList.modes);
      // this.DeviceList.modes
      const deviceMode = this.findDeviceData(
        this.DeviceList.modes,
        "DeviceID",
        deviceID
      );
      // console.log(deviceID);
      // console.log(deviceMode);

      var mode =
        deviceMode !== undefined ? deviceMode[0]["payload"]["Mode"] : "";
      var resp = "--";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
        // code block
      }
      return resp;
    },
    expiryDate(deviceID) {
      const deviceExpiry = this.findDeviceData(
        this.DeviceList.expiries,
        "DeviceID",
        deviceID
      );

      return deviceExpiry !== undefined
        ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"])
        : "--";
    },
    timeAgo(date, name) {
      // console.log(name);
      // console.log(this.timeRightNow);
      // console.log(date);

      // var difference = date.add(1, "hours").fromNow();
      // var difference = Math.abs(this.timeRightNow.diff(date));
      // console.log(moment(date).from(this.timeRightNow));
      // console.log("==============================================");
      return moment(date).from(this.timeRightNow);
      // return timeAgoUtil(difference);
      // console.log(moment(date, "Africa/Lagos").fromNow());
      // if (difference / 60000 > 90) {
      //   return true;
      // } else {
      //   return false;
      // }

      // return moment(date)
      //   .add(1, "hours")
      //   .format()
      //   .toString();
    },
    statusCalc(date) {
      // console.log( moment(date).diff(this.timeRightNow));
      var difference = Math.abs(moment(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    statusLabel(date) {
      var difference = Math.abs(moment().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    panelPower(PVChargingPower) {
      // console.log(parameters);
      var power = this.roundUp((PVChargingPower * 1) / 1000);
      return power + " kW";
    },
    powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    sortDevice(params) {
      this.sortField = params[0].field;
      this.sortOrder = params[0].type;
      return params;
    },
    async fetchDevices() {},
    async getCurrentCustomerDeviceIds() {
      const httpUtils = this.$httpUtils;
      let userId = this.getUserSession.id;
      let url = `/installations?filter={"where":{"and": [{"userId":${userId}}, {"or":[{ "status": "requested"},{ "status": "commissioned"},{ "status": "completed"}]}]}}`;
      const result = await httpUtils.instance.get(url);
      const res = result.data.map(item => item.CID);
      this.$store.commit("setAssignedDevices", res);
      return res;
    },
    async currentTime() {
      const me = this;
      const HTTP = this.$httpUtils.instance;
      try {
        let response = await HTTP.get(
          "https://arnergy.com/weather-api/time/?" + Date.now()
        );
        if (response) {
          if (response.data.datetime) {
            let tmpDate = response.data.datetime.split(".")[0];
            return tmpDate;
          }
        }
      } catch (e) {
        return new Date();
      }
    },
    get() {
      this.$socket.emit(
        "get",
        JSON.stringify({ action: "sendMessage" }),
        response => {
          console.log(response);
        }
      );
    },
    add() {
      // Emit the server side
      this.$socket.emit("add", JSON.stringify({ action: "sendMessage" }));
    },
    sleep(ms) {
      // console.log(ms + "here");

      return new Promise(resolve => setTimeout(resolve, ms));
    }
    // checkOnboardedCustomer(id) {
    //   const HTTP = this.$httpUtils.instance;

    //   HTTP.get(
    //     `/onboardingStates/findOne?filter={"where":{"customerid":${id}}}`
    //   )
    //     .then((response) => {
    //       if (response.data.stateid < 7) window.location.href = "/onboarding";
    //       if (response.data.stateid == 7)
    //         window.location.href = "/onboarding/finish-tab";
    //     })
    //     .catch((error) => {
    //       console.log({ error });
    //     });
    // },
  },
  watch: {
    paginatedInfo: async function(n, o) {
      if (n.first !== o.first) {
        await this.getDevices({ ...this.getParams });
      }
    },
    getSortOrder: async function(n, o) {
      if (n.sortField !== o.sortField || n.sortOrder !== o.sortOrder) {
        await this.getDevices({
          ...this.getParams,
          sortField: this.selectedField(n.sortField),
          sortOrder: n.sortOrder
        });
      }
    },
    tableOptions: async function(n, o) {
      if (
        n.currentPage !== o.currentPage ||
        n.currentPerPage !== o.currentPerPage
      ) {
        await this.getDevices({ ...this.getParams });
      }
    },
    searchTerm: debounce(async function(n, o) {
      if (n !== o) {
        await this.getDevices({ ...this.getParams });
      }
    }, 600)
  },
  created() {},
  async mounted() {
    // this.checkOnboardedCustomer(this.getUserSession.id)
    this.toggleFilters();
    if (localStorage.getItem("roleType") == "customer") {
      this.isCustomer = true;
    }
    this.totalDevicesShowing = this.filteredAllDevices.length;
    // https://worldtimeapi.org/api/timezone/Africa/Lagos
    // await this.
    if (this.$can("see", "installation")) {
      this.showOffOnlinelineDevices = this.getPerformanceFilter;
    }
    this.timeRightNow = await this.currentTime();
    let { timeRightNow } = this;
    // console.log({timeRightNow});
    if (this.$can("am", "customer")) {
      // I am a customer...
      // console.log({whoami:"Customer"});
      const deviceIds =
        this.getAssignedDevices != null
          ? this.getAssignedDevices
          : await this.getCurrentCustomerDeviceIds(); // ==> ['416931', '416850'];
      // alert(deviceIds);
      if (deviceIds.length < 1) {
        this.showOffOnlinelineDevices = null;
        return;
      }
      this.performanceGraphCall2({
        arrayOfIds: deviceIds,
        ...this.getParams,
        filter: this.selectMode(this.getPerformanceFilter)
      }).then(res => {
        this.$nextTick(() => {
          if (localStorage.getItem("reloaded")) {
            localStorage.removeItem("reloaded");
          } else {
            localStorage.setItem("reloaded", "1");
            location.reload();
          }
        });
      });
    } else if (this.$can("am", "sm")) {
      // I am a section manager...
      let assignedDevices = [];
      try {
        assignedDevices = JSON.parse(this.getUserSession.assignedDevices);
      } catch (error) {
        assignedDevices = this.getUserSession.assignedDevices.split(",");
      }
      this.performanceGraphCall2({
        timeRN: this.timeRightNow,
        arrayOfIds: assignedDevices,
        ...this.getParams,
        filter: this.selectMode(this.getPerformanceFilter)
      }).then(res => {
        this.$nextTick(() => {
          if (localStorage.getItem("reloaded")) {
            localStorage.removeItem("reloaded");
          } else {
            localStorage.setItem("reloaded", "1");
            location.reload();
          }
        });
      });
    } else if (this.$can("manage", "allDevices")) {
      this.performanceGraphCall2({
        timeRN: this.timeRightNow,
        filter: this.selectMode(this.getPerformanceFilter)
      }).then(res => {
        this.$nextTick(() => {
          if (localStorage.getItem("reloaded")) {
            // localStorage.removeItem("reloaded");
          } else {
            localStorage.setItem("reloaded", "1");
            location.reload();
          }
        });
      });
    }
    let filtrdIssues = this.filterIssues();
    this.setCriticalSystems(filtrdIssues);
  }
};
</script>

<style lang="scss">
h1,
h2,
p {
  margin: 0;
}
.dashboard {
  padding: 20px;
  background-color: white;
}
.content-area {
  background-color: white;
}
.page-content__header-description,
.container-fluid {
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
.page-title {
  margin: 50px 0;
  color: black;
}
.label-container {
  display: flex;
}
.label-container > div {
  margin-right: 10px;
}
.label-container > div:last-child {
  margin-right: 0px;
}
.default-label {
  background-color: #ffffff;
  border: 1.5px solid #d9d9d9;
  border-radius: 15px;
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
}
.default-label p {
  font-size: 15px;
  margin-bottom: 0px;
}
.default-label .green-label {
  color: #606266;
}

.default-label .orange-label {
  color: #606266;
}
.active-orange-filter {
  background-color: rgb(254, 122, 17);
}

.default-label .yellow-label {
  color: #606266;
}
.active-yellow-filter {
  background-color: rgb(219, 179, 0);
}
.default-label .red-label {
  color: #606266;
}
.active-red-filter {
  background-color: rgb(255, 0, 0);
}
.default-label .blue-label {
  color: #606266;
}
.active-blue-filter {
  background-color: rgb(26, 147, 201);
}
.active-blue-filter p.blue-label,
.active-red-filter p.red-label,
.active-yellow-filter p.yellow-label,
.active-green-filter p.green-label,
.active-orange-filter p.orange-label {
  color: rgba(255, 255, 255, 0.75);
}
.default-label .device-amount {
  color: #1e2833;
  margin-left: 10px;
  font-size: 15px;
}
.active-blue-filter .device-amount,
.active-red-filter .device-amount,
.active-yellow-filter .device-amount,
.active-green-filter .device-amount,
.active-orange-filter .device-amount {
  color: rgb(255, 255, 255);
}

.active-green-filter,
.active-orange-filter,
.active-yellow-filter,
.active-blue-filter,
.active-red-filter {
  background-color: rgb(68, 69, 67);
}

.active-green-filter,
.active-orange-filter,
.active-yellow-filter,
.active-blue-filter,
.active-red-filter p {
  color: "white";
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.display-search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.info-container {
  display: flex;
  align-items: center;
}

.info-icon {
  margin-top: 20px;
  margin-bottom: 1rem;
  margin-left: 6px;
  cursor: pointer;
}

.el-input--prefix .el-input__inner {
  border-radius: 10px;
  width: 360px;
  background-color: #eff0f4;
  border-color: #eff0f4;
}
.hide_row {
  display: hidden !important;
}
.loadingState {
  animation-direction: alternate;
}
.activeFilter {
  font-size: 93% !important;
}
.critical_pin * {
  color: red !important;
}
.main-container {
  height: calc(100vh - 330px);
}
.pagination-strip {
  background-color: white;
}
.info_banner {
  font-size: 18px;
  padding: 10px;
  background-color: #016fb9;
  color: white;
  text-align: center;
  border-radius: 12px;
}

.important-text {
  font-weight: bold;
}

.app-link:hover,
.app-link {
  cursor: pointer;
  color: white;
  margin: 0 5px;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/index3.vue